// Widget Studio — instance list page (CHG-2460 / ITER-905202, Widget Studio S3).
//
// Thin wrapper: all configuration in @generated/screens/widget-instance-list,
// regenerated from specs/tier-05-experience/widget-instance.entity-hint.yaml.
// Mounts under the Channels nav group at /channels/widgets.

import { ListPage } from "../components/composition";
import { widgetInstanceListConfig } from "../generated/screens/widget-instance-list";

export function Widgets() {
  return <ListPage config={widgetInstanceListConfig} />;
}
